<template>
  <div class="filter-directory mb-5" v-if="directoryCountries && directoryCountries.length > 0">
    <a class="collapsed d-flex background-white p-4 color-black align-items-center position-relative"
       data-toggle="collapse" href="#filter-location-mark" role="button" aria-expanded="true"
       :aria-controls="translate('hdShowFilters')">
      <i class="icon-world md mr-3"></i><span>{{translate('hdWhereIWouldLikeToStay')}}</span>
      <i class="icon-arrow-up xxs"> </i>
    </a>
    <div class="position-relative">
      <div class="collapse show bg-color-alabaster px-5 pt-5 pb-2" id="filter-location-mark">
        <div class="row">

          <div class="col-lg-4 form-group px-3" >
            <input
              type="text"
              class="form-control read-only-arrow"
              id="countrySelector"
              :value="directory.selectedCountry ? directory.selectedCountry.name : translate('hdSelectACountry')"
              readonly
              required
              @focus="toggleFocus('countrySelector')"
              @click="toggleFocus('countrySelector')"
            />
            <label for="countrySelector" class="label-up">{{ translate('hdCountry') }}</label>
            <div
              class="options-group"
              v-if="focus === 'countrySelector'">
                <div class="options-content">
                  <span class="option-header">{{ translate('hdCountries') }}</span>
                  <ul role="menu">
                    <li
                    class="row align-items-center"
                    role="menuitem"
                    @click="selectCountry(country)"
                    v-for="country in directoryCountries" :key="country.code">
                      <div class="col-12">
                        <span :class="directory.selectedCountry && directory.selectedCountry.code === country.code ? 'font-bold' :''">{{ country.name }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
            </div>
          </div>

          <div class="col-lg-4 form-group px-3" v-if="directoryStates && directoryStates.length > 0">
            <input
              type="text"
              class="form-control read-only-arrow"
              id="stateSelector"
              :value="directory.selectedState ? directory.selectedState.name : translate('hdSelectAState')"
              readonly
              required
              @focus="toggleFocus('stateSelector')"
              @click="toggleFocus('stateSelector')"
            />
            <label for="stateSelector" class="label-up">{{ translate('hdState') }}</label>
            <div
              class="options-group"
              v-if="focus === 'stateSelector'">
                <div class="options-content">
                  <span class="option-header">{{ translate('hdStates') }}</span>
                  <ul role="menu">
                    <li
                    class="row align-items-center"
                    role="menuitem"
                    @click="selectState(state)"
                    v-for="state in directoryStates" :key="state.code">
                      <div class="col-12">
                        <span :class="directory.selectedState && directory.selectedState.code === state.code ? 'font-bold' :''">{{ state.name }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
            </div>
          </div>

          <div class="col-lg-4 form-group px-3" v-if="directoryCities && directoryCities.length > 0">
            <input
              type="text"
              class="form-control read-only-arrow"
              id="citySelector"
              :value="directory.selectedCity ? directory.selectedCity.name : translate('hdSelectACity')"
              readonly
              required
              @focus="toggleFocus('citySelector')"
              @click="toggleFocus('citySelector')"
            />
            <label for="citySelector" class="label-up">{{ translate('hdCity') }}</label>
            <div
              class="options-group"
              v-if="focus === 'citySelector'">
                <div class="options-content">
                  <span class="option-header">{{ translate('hdCities') }}</span>
                  <ul role="menu">
                    <li
                    class="row align-items-center"
                    role="menuitem"
                    @click="selectCity(city)"
                    v-for="city in directoryCities" :key="city.name">
                      <div class="col-12">
                        <span :class="directory.selectedCity && directory.selectedCity.name === city.name ? 'font-bold' :''">{{ city.name }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'FilterLocation',
  computed: {
    ...mapGetters([
      'directoryCountries',
      'directoryStates',
      'directoryCities']),
    ...mapState([
      'directory',
      'focus'])
  },
  async created () {
    document.addEventListener('click', this.unFocus)
    document.addEventListener('touchstart', this.unFocus)
    await this.$store.dispatch('getDirectoryCountries')
  },
  methods: {
    async selectCountry (country) {
      this.$store.commit('loading')
      this.$store.dispatch('setSelectedDirectoryCountry', country)
      this.$store.dispatch('toggleFocus', 'countrySelector')
      await this.$store.dispatch('getDirectoryCitiesOrStates', country.code)
      this.$store.dispatch('getDirectoryHotels')
      this.$store.commit('free')
    },
    async selectState (state) {
      this.$store.commit('loading')
      this.$store.dispatch('setSelectedDirectoryState', { selectedCountry: this.directory.selectedCountry, selectedState: state })
      this.$store.dispatch('toggleFocus', 'stateSelector')
      await this.$store.dispatch('getDirectoryCities', { countryCode: this.directory.selectedCountry.code, stateCode: state.code })
      this.$store.dispatch('getDirectoryHotels')
      this.$store.commit('free')
    },
    selectCity (city) {
      this.$store.commit('loading')
      this.$store.dispatch('setSelectedDirectoryCity', {
        selectedCountry: this.directory.selectedCountry,
        selectedState: this.directory.selectedState,
        selectedCity: city
      })
      this.$store.dispatch('toggleFocus', 'citySelector')
      this.$store.dispatch('getDirectoryHotels')
      this.$store.commit('free')
    },
    toggleFocus: debounce(function (selector) {
      this.$store.dispatch('toggleFocus', selector)
    }, 300, {
      leading: true,
      trailing: false
    }),
    unFocus (event) {
      const isClickOutsideFilters = global.$(event.target).closest('.form-group').length === 0
      if (isClickOutsideFilters) {
        this.$store.dispatch('toggleFocus')
      }
    }
  },
  destroyed () {
    document.removeEventListener('click', this.unFocus)
    document.removeEventListener('touchstart', this.unFocus)
  }
}
</script>

<style scoped>
  .label-up {
    left: 9px;
  }

  .form-group {
    float: initial;
  }

  .collapse.show {
    height: 100%;
    overflow: visible;
  }

  .filter-directory .icon-arrow-up {
    position: absolute;
    right: 15px;
  }

</style>
